export const WORDS = [
  'grice',

  'panda',

  'tapir',

  'aguti',

  'eagle',

  'kulan',

  'fitch',

  'stirk',

  'chimp',

  'coati',

  'coney',

  'bongo',

  'snake',

  'macaw',

  'egret',

  'brock',

  'nagor',

  'royal',

  'tigon',

  'nyala',

  'urial',

  'orang',

  'civet',

  'rhino',

  'pekan',

  'fossa',

  'addax',

  'urson',

  'canis',

  'whelp',

  'eland',

  'lemur',

  'manis',

  'cuddy',

  'kyloe',

  'filly',

  'dingo',

  'phoca',

  'okapi',

  'hyena',

  'saiga',

  'sheep',

  'potto',

  'koala',

  'manul',

  'shrew',

  'oribi',

  'bitch',

  'burro',

  'whale',

  'otary',

  'mouse',

  'gayal',

  'bison',

  'takin',

  'hyrax',

  'sasin',

  'coypu',

  'vixen',

  'izard',

  'heron',

  'shoat',

  'sable',

  'camel',

  'tabby',

  'spado',

  'vison',

  'mhorr',

  'hippo',

  'sloth',

  'crane',

  'llama',

  'chick',

  'quoll',

  'bobac',

  'viper',

  'magot',

  'hinny',

  'genet',

  'daman',

  'kaama',

  'tiger',

  'zebra',

  'shote',

  'ratel',

  'morse',

  'hutia',

  'tatou',

  'quail',

  'goral',

  'jocko',

  'crone',

  'moose',

  'goose',

  'pongo',

  'ammon',

  'ounce',

  'sajou',

  'liger',

  'kiang',

  'tahar',

  'dhole',

  'akita',

  'sorel',

  'steer',

  'swine',

  'serow',

  'bruin',

  'indri',

  'horse',

  'skunk',

  'gryce',

  'stoat',

  'cobra',

  'booby',

  'otter',

  'drill',

  'puppy',

  'chiru',

  'billy',

  'mcnab',

  'kerry',

  'jindo',

  'alano',

  'irish',

  'husky',

  'dwelf',

  'cesky',

  'plott',

  'lykoi',

  'spitz',

  'silky',

  'korat',

  'satyr',

  'queen',

  'larva',

  'aphid',

  'drone',

  'midge',

  'imago',

  'aphis',

  'snail',

  'louse',

  'midge',

  'gecko',

  'robin',

  'finch',

  'shark',

  'oxeye',

  'mynah',

  'noddy',

  'ousel',

  'stork',

  'pipit',

  'scaup',

  'stilt',

  'stork',

  'snipe',

  'stilt',

  'brant',

  'crake',

  'diver',

  'junco',

  'merle',

  'miner',

  'twite',
]
